<template>
  <vz-card class="vz-order-total-card">
    <div v-if="!hasList" class="vz-order-total-card-title vz-personal-order-total-card-item">
      <span class="mr-10">
        Опись груза
      </span>
      <vz-button
        outline
        class="ml-auto"
        icon-name="plus"
        variant="info"
        :disabled="disabled"
        @click="onOpenModal"
      >
        Добавить
      </vz-button>
    </div>
    <div v-else>
      <div class="vz-order-total-card-title vz-personal-order-total-card-item">
        <span>Опись груза</span>
        <vz-price
          v-if="!visible"
          :flag="flag"
          :total-price="totalPrice"
          :currency-measure="currencyMeasure"
        />
        <vz-button
          v-if="hasToggle"
          :icon-name="toggleIcon"
          rounded
          class="ml-auto"
          @click="visible = !visible"
        />
      </div>
      <div v-if="visible" class="mt-20 vz-personal-order-total-card-item">
        <div
          v-for="item of manifestData"
          class="text-body mb-10 flex"
        >
          <div>{{ item.tnVed }}</div>
          <vz-tooltip-info class="ml-10" :text="item.inventoryName" />
          <div class="ml-auto">
            {{ item.price }} {{ currencyMeasure }}
          </div>
        </div>
        <hr>
        <div class="flex flex-align-items-center">
          <span class="text-subtitle">Итого:</span>
          <vz-price
            class="ml-auto text-h1"
            :flag="flag"
            :total-price="totalPrice"
            :currency-measure="currencyMeasure"
          />
        </div>
        <div class="flex flex-center">
          <vz-button
            variant="primary"
            class="mt-25"
            @click="onOpenModal"
          >
            {{ editTitle }}
          </vz-button>
        </div>
      </div>
    </div>
  </vz-card>
</template>

<script setup lang="ts">
import {useOrderStore} from '@/stores/order';
import VzButton from '~/components/ui-kit/vz-button.vue';
import {priceFormat} from '~/common/price';
import VzTooltipInfo from '~/components/ui-kit/vz-tooltip-info.vue';
import VzPrice from '~/components/personal/vz-price.vue';
import {getCountryFlagIcon, getCurrencyText} from '~/common/objects';

const props = defineProps({
  hasToggle: {
    type: Boolean,
    default: true
  }
})

const { $showDialog } = useNuxtApp()
const orderStore = useOrderStore()
const route = useRoute()

const visible = ref(true)

const guid = computed(() => {
  return route.params.guid?.toString()
})

const toggleIcon = computed(() => {
  return visible.value ? 'chevron-up' : 'chevron-down'
})

const manifestData = computed(() => {
  if (!guid.value) {
    return false
  }
  return orderStore.loadingManifest
})

const disabled = computed(() => {
  return orderStore.orderForm.meta?.isLoadingManifestLocked
})

const editTitle = computed(() => {
  return disabled.value ? 'Просмотреть' : 'Редактировать'
})

const hasList = computed(() => {
  return manifestData.value && !!manifestData.value?.length
})

const currency = computed(() => {
  if (manifestData.value && manifestData.value.length) {
    return manifestData.value[0]?.currency
  }
  return orderStore.orderForm?.directions.dispatch.country || orderStore.orderForm?.currency
})

const currencyMeasure = computed(() => {
  return getCurrencyText(currency.value, currency.value === 'RU')
})

const flag = computed(() => {
  return getCountryFlagIcon(currency.value)
})

const totalPrice = computed(() => {
  if (!manifestData.value) {
    return 0
  }
  let sum = 0
  manifestData.value.forEach((item) => {
    sum += item.price
  })
  return priceFormat(sum)
})

function onOpenModal() {
  $showDialog({name: 'vz-manifest-modal'})
}

onMounted(() => {
  if (!props.hasToggle) {
    visible.value = true
  }
})
</script>
